import { getMapper } from "features/Library/Common/QuestionsForm/Questions/QuestionMappers/QuestionToQuestionMapper";
import { type MapResult } from "features/Library/Common/models";
import { type RatingScale, type SurveyQuestion } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";
import { getQuestionDefaultData } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/SurveyProviders/defaultQuestionProvider";
import { SurveyQuestionType } from "features/Library/Surveys/types/models";

/* istanbul ignore next */
const questionToQuestionMap = (() => {
  const mapper = getMapper();

  mapper
    .map()
    .from(SurveyQuestionType.MultipleChoiceTextQuestion)
    .to(SurveyQuestionType.SingleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return { ...input, questionType: SurveyQuestionType.SingleChoiceTextQuestion };
    })
    .to(SurveyQuestionType.FreeText)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.FreeText),
        isRequired: input.isRequired,
        question: input.question,
      };
    })
    .to(SurveyQuestionType.RatingScale)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<RatingScale> => {
      const data = getQuestionDefaultData(SurveyQuestionType.RatingScale);
      return {
        ...data,
        isRequired: input.isRequired,
        question: {
          ...data.question,
          text: input.question,
        },
      };
    });

  mapper
    .map()
    .from(SurveyQuestionType.SingleChoiceTextQuestion)
    .to(SurveyQuestionType.MultipleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return { ...input, questionType: SurveyQuestionType.MultipleChoiceTextQuestion };
    })
    .to(SurveyQuestionType.FreeText)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.FreeText),
        isRequired: input.isRequired,
        question: input.question,
      };
    })
    .to(SurveyQuestionType.RatingScale)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<RatingScale> => {
      const data = getQuestionDefaultData(SurveyQuestionType.RatingScale);
      return {
        ...data,
        isRequired: input.isRequired,
        question: {
          ...data.question,
          text: input.question,
        },
      };
    });

  mapper
    .map()
    .from(SurveyQuestionType.FreeText)
    .to(SurveyQuestionType.MultipleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.MultipleChoiceTextQuestion),
        isRequired: input.isRequired,
        question: input.question,
      };
    })
    .to(SurveyQuestionType.SingleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.SingleChoiceTextQuestion),
        isRequired: input.isRequired,
        question: input.question,
      };
    })
    .to(SurveyQuestionType.RatingScale)
    .mapper((input: SurveyQuestion<string>): SurveyQuestion<RatingScale> => {
      const data = getQuestionDefaultData(SurveyQuestionType.RatingScale);
      return {
        ...data,
        isRequired: input.isRequired,
        question: {
          ...data.question,
          text: input.question,
        },
      };
    });

  mapper
    .map()
    .from(SurveyQuestionType.RatingScale)
    .to(SurveyQuestionType.MultipleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<RatingScale>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.MultipleChoiceTextQuestion),
        isRequired: input.isRequired,
        question: input.question.text,
      };
    })
    .to(SurveyQuestionType.SingleChoiceTextQuestion)
    .mapper((input: SurveyQuestion<RatingScale>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.SingleChoiceTextQuestion),
        isRequired: input.isRequired,
        question: input.question.text,
      };
    })
    .to(SurveyQuestionType.FreeText)
    .mapper((input: SurveyQuestion<RatingScale>): SurveyQuestion<string> => {
      return {
        ...getQuestionDefaultData(SurveyQuestionType.FreeText),
        isRequired: input.isRequired,
        question: input.question.text,
      };
    });

  return mapper.create();
})();

/* istanbul ignore next */
export const MapQuestion = (to: SurveyQuestionType, input: SurveyQuestion<any>): MapResult<SurveyQuestion<any>> => {
  const mapper = questionToQuestionMap[input.questionType]?.[to];

  if (mapper) {
    return { question: mapper(input), success: true };
  }
  const defaultData = getQuestionDefaultData(to);
  return { question: { ...defaultData }, success: false };
};
